<!-- project/src/components/UserLogin.vue -->
<template>
    <div class="login-container">
      <h1>User Login</h1>
      <form @submit.prevent="login" class="login-form">
        <input type="text" v-model="username" placeholder="Username" required class="input-field" />
        <input type="text" v-model="email" placeholder="Email" required class="input-field" />
        <input type="password" v-model="password" placeholder="Password" required class="input-field" />
        <button type="submit" class="submit-button">Login</button>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    name: 'UserLogin',
    data() {
      return {
        username: '',
        password: ''
      };
    },
    methods: {
      login() {
        console.log('Logging in with', this.username, this.password);
      }
    }
  };
  </script>
  
  <style scoped>
  .login-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #f0f0f0;
  }
  
  .login-form {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  .input-field {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .submit-button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .submit-button:hover {
    background-color: #0056b3;
  }
  </style>
  